var render = function () {
  var _vm$clearanceApproval, _vm$clearanceApproval2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "rounded": "",
      "color": _vm.color,
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s((_vm$clearanceApproval = _vm.clearanceApproval.seller) === null || _vm$clearanceApproval === void 0 ? void 0 : _vm$clearanceApproval.name) + " "), _c('v-spacer'), !_vm.clearanceApproval.isCompleted ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.isCreateDialogOpen = true;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1) : _vm._e(), _vm.clearanceApproval.lastSharedContent ? _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !((_vm$clearanceApproval2 = _vm.clearanceApproval) !== null && _vm$clearanceApproval2 !== void 0 && _vm$clearanceApproval2.lastSharedContent)
    },
    on: {
      "click": function click($event) {
        var _vm$clearanceApproval3;

        _vm.sharedContentSideCardItem = (_vm$clearanceApproval3 = _vm.clearanceApproval) === null || _vm$clearanceApproval3 === void 0 ? void 0 : _vm$clearanceApproval3.lastSharedContent;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-link-variant")])], 1) : _vm._e(), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.goToDetail();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1), _c('v-card-subtitle', {
    staticClass: "text-xs"
  }, [_c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.clearanceApproval.timestamp.createdReadable) + " ")])], 1), _c('v-card-actions', {
    staticClass: "px-4 pb-4"
  }, [_vm.clearanceApproval.status === _vm.RequestStatusEnum.DRAFT ? _c('v-btn', {
    attrs: {
      "small": "",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        _vm.isDialogOpen = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v(" mdi-send-variant-outline ")]), _vm._v(" " + _vm._s(_vm.$t("submit")) + " ")], 1) : _c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": _vm.clearanceApproval.statusColor,
      "outlined": _vm.clearanceApproval.status !== _vm.RequestStatusEnum.REQUESTED
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": "",
      "color": _vm.clearanceApproval.statusColor
    }
  }, [_vm._v(" " + _vm._s(_vm.clearanceApproval.statusIcon) + " ")]), _vm._v(" " + _vm._s(_vm.$t("enums.RequestStatusEnum.".concat(_vm.clearanceApproval.status))) + " ")], 1)], 1), _c('report-clearance-approval-request-dialog', {
    attrs: {
      "clearanceApproval": _vm.clearanceApproval
    },
    model: {
      value: _vm.isDialogOpen,
      callback: function callback($$v) {
        _vm.isDialogOpen = $$v;
      },
      expression: "isDialogOpen"
    }
  }), _c('report-clearance-approval-update-status-dialog', {
    attrs: {
      "clearanceApproval": _vm.clearanceApproval
    },
    model: {
      value: _vm.isCreateDialogOpen,
      callback: function callback($$v) {
        _vm.isCreateDialogOpen = $$v;
      },
      expression: "isCreateDialogOpen"
    }
  }), _vm.sharedContentSideCardItem ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.sharedContentSideCardItem,
      "referenceCategories": [_vm.ResourceEnum.DOCUMENT, _vm.ResourceEnum.RENTAL, _vm.ResourceEnum.APPRAISAL, _vm.ResourceEnum.REPAIR_ESTIMATE, _vm.ResourceEnum.CLEARANCE, _vm.ResourceEnum.CLEARANCE_APPROVAL],
      "suggested": _vm.report.suggestedRefs,
      "hideSuggested": false,
      "filters": _vm.filters
    },
    on: {
      "close": function close($event) {
        _vm.sharedContentSideCardItem = null;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }